import { useState, useCallback } from 'react';
import axios from 'axios';

export const useNodes = () => {
  const [nodes, setNodes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchNodes = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const token = localStorage.getItem('access_token');
      const response = await axios.get('/api/admin/nodes', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setNodes(Array.isArray(response.data) ? response.data : []);
    } catch (err) {
      console.error('Failed to fetch nodes:', err);
      setError('Не удалось загрузить ноды');
    } finally {
      setLoading(false);
    }
  }, []);

  const createNode = useCallback(async (data) => {
    try {
      const token = localStorage.getItem('access_token');
      await axios.post('/api/admin/nodes', data, {
        headers: { Authorization: `Bearer ${token}` }
      });
      await fetchNodes();
      return { success: true };
    } catch (err) {
      console.error('Failed to create node:', err);
      if (err.response?.status === 401) {
        return { success: false, error: 'Требуется аутентификация' };
      } else if (err.response?.status === 403) {
        return { success: false, error: 'Требуются права администратора' };
      }
      return { success: false, error: err.response?.data?.error || 'Не удалось создать ноду' };
    }
  }, [fetchNodes]);

  const updateNode = useCallback(async (id, data) => {
    try {
      const token = localStorage.getItem('access_token');
      await axios.patch(`/api/admin/nodes/${id}`, data, {
        headers: { Authorization: `Bearer ${token}` }
      });
      await fetchNodes();
      return { success: true };
    } catch (err) {
      console.error('Failed to update node:', err);
      if (err.response?.status === 401) {
        return { success: false, error: 'Требуется аутентификация' };
      } else if (err.response?.status === 403) {
        return { success: false, error: 'Требуются права администратора' };
      }
      return { success: false, error: err.response?.data?.error || 'Не удалось обновить ноду' };
    }
  }, [fetchNodes]);

  const deleteNode = useCallback(async (id) => {
    try {
      const token = localStorage.getItem('access_token');
      await axios.delete(`/api/admin/nodes/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      await fetchNodes();
      return { success: true };
    } catch (err) {
      console.error('Failed to delete node:', err);
      if (err.response?.status === 401) {
        return { success: false, error: 'Требуется аутентификация' };
      } else if (err.response?.status === 403) {
        return { success: false, error: 'Требуются права администратора' };
      }
      return { success: false, error: err.response?.data?.error || 'Не удалось удалить ноду' };
    }
  }, [fetchNodes]);

  return { nodes, loading, error, fetchNodes, createNode, updateNode, deleteNode };
};